// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1eT5Y","footer":"ModalError_footer__1IzZQ"};